module.exports = __webpack_public_path__ + "components/tooltips/static/chill-08df424a1ff77edf22acc329127ea348.jpg";